import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";

const InstallPwa = (props) => {
    const { titleAria, titleButton, appId } = props.attributes;
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsVisible(true);
        };

        const handleAppInstalled = () => {
            console.log("PWA was installed");
            // Отправляем запрос на сервер для записи установки
            axios
                .post("/setSocialClicks", {
                    platform: "pwa-installed",
                    appId: appId,
                })
                .then((response) => {
                    console.log("Installation recorded:", response.data);
                })
                .catch((error) => {
                    console.error("Error recording installation:", error);
                });
        };

        window.addEventListener(
            "beforeinstallprompt",
            handleBeforeInstallPrompt
        );
        window.addEventListener("appinstalled", handleAppInstalled);

        return () => {
            window.removeEventListener(
                "beforeinstallprompt",
                handleBeforeInstallPrompt
            );
            window.removeEventListener("appinstalled", handleAppInstalled);
        };
    }, [appId]);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    console.log("User accepted the A2HS prompt");
                } else {
                    console.log("User dismissed the A2HS prompt");
                }
                setDeferredPrompt(null);
                setIsVisible(false);
            });
        }

        // Отправляем запрос на сервер для записи клика
        /* axios
            .post("/setSocialClicks", {
                platform: "pwa",
                appId: appId,
            })
            .then((response) => {
                console.log("Click recorded:", response.data);
            })
            .catch((error) => {
                console.error("Error recording click:", error);
            }); */
    };

    return (
        isVisible && (
            <button
                onClick={handleInstallClick}
                className="md:bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 md:text-white md:font-bold md:py-3 md:px-6 md:rounded-lg md:shadow-lg md:transform md:transition-transform md:duration-300 md:hover:scale-105 md:hover:shadow-2xl bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 text-white font-bold py-2 px-4 rounded-lg shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-xl"
                title={titleAria}
            >
                {titleButton}
            </button>
        )
    );
};

document.addEventListener("DOMContentLoaded", () => {
    const els = document.getElementsByClassName("install-pwa");

    Array.from(els).forEach((el) => {
        const root = createRoot(el);
        const attributes = {
            titleAria: el.getAttribute("titleAria"),
            titleButton: el.getAttribute("titleButton"),
            appId: el.getAttribute("appId"),
        };
        root.render(<InstallPwa attributes={attributes} />);
    });
});
